import { object, string } from "yup";
import { VALIDATION_RULES } from "@lib/constants/formValidations";
import { emailRegex } from "../regex/general";

export interface LogInHeaders {
    requiredField: string;
    email: string;
    maxCharacters?: string;
}

export function getEmailValidationSchema(headers: LogInHeaders, emailLabel?: string) {
    return object().shape({
        email: string()
            .trim()
            .label(emailLabel)
            .required()
            .matches(emailRegex, headers.email)
            .max(VALIDATION_RULES.email.maxCharacters, headers.maxCharacters),
    });
}

export function getLogInValidationSchema(
    headers: LogInHeaders,
    labels: { email: string; password: string }
) {
    return object().shape({
        email: string()
            .trim()
            .label(labels.email)
            .required()
            .matches(emailRegex, headers.email)
            .max(VALIDATION_RULES.email.maxCharacters, headers.maxCharacters),
        password: string().label(labels.password).required(),
    });
}
